export const INTEGRATION = "integration";
export const INTEGRATIONS = "integrations";
export const INTEGRATION_SERVICE = "integration_service";
export const PERMISSION = "permission";
export const TOU = "tou";
